<template>
  <div class="goods-image">
    <div class="w1200">
      <!-- 1111111111111111111111 -->
      <el-row>
        <el-col :span="18">
          <div class="goods-info">
            <div class="media">
              <GoodsImage :images="swiperList"></GoodsImage>
            </div>
            <div class="spec">
              <!-- <GoodsName :goods="goods"></GoodsName> -->
              <div class="goods-sku">
                <p class="clap">
                  新能-粗醇
                </p>
                <div class="rechargeItem">
                  <div class="iponer">
                    <p class="g-price">
                      <span class="g-rena">意向价格</span>
                      <span class="g-mkous">
                        ￥21541
                      </span>
                      <span class="g-resa">
                        / 吨
                      </span>
                    </p>
                    <p class="posasa">
                      <i class="
                          el-icon-magic-stick" style="color:#FFB71C;"></i>
                      <span class="riesa">明标</span>
                    </p>
                    <p class="g-price">
                      <span class="g-rena">抢购底价</span>
                      <span class="g-mkous">
                        ￥21000
                      </span>
                      <span class="g-resa">
                        / 吨
                      </span>
                    </p>
                  </div>
                  <div class="iperssaa">
                    <span>距离结束还有</span>

                    <span class="miaosha">
                      {{count}}
                    </span>
                  </div>
                </div>
              </div>




              <div>
                <div class="container">
                  <span class="item" v-for="(commodity,index) in marst" :key="index"> <i
                      class="i-colea">{{commodity.name}}</i>
                    <i class="i-coleasss">{{commodity.province}}</i></span>

                </div>
                <!-- <div v-for="(commodity,index) in marst" :key="index">
                        <p class="displa">
                          {{commodity.name}} {{commodity.province}}
                        </p>
                      </div> -->
              </div>
              <button class="xtx-button ellipsis">
                立即购买
              </button>

              <button class="fhas-buttons ellipsis">
                停售
              </button>
              <!-- <XtxButton @click="insertCart()" type="primary" style="margin-top: 20px">加入购物车</XtxButton> -->


              <div>
                <i class="el-icon-apple"></i>
                <span class="shoucan">收藏产品</span>


                <span class="shoucan">点击查看规则</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="bang-rigth">

            <span class="gongsi">
              公司信息
            </span>

            <div class="borearss">


            </div>

            <div style="text-align: center;">
              <span class="mokisa huanghang">
                北方XXXXXXXX化工有限公司
              </span>

            </div>

            <div class="xian">

            </div>

            <div class="moaksa">
              <span class="siaosaf">
                企业认证
              </span>

              <div class="siaosaf-q">

                <el-button class="anniu" type="primary" size="mini" icon="el-icon-check">已认证
                </el-button>
              </div>

            </div>


            <div style="    margin-top: 20px;">


              <span class="siaosaf">
                企业认证
              </span>

              <span class="mokisa huanghang">
                北方XXXXXXXX化工有限公司
              </span>

            </div>

            <div class="moiuysa">

              + 立即关注
            </div>




          </div>
        </el-col>
      </el-row>
      <!-- 11111111111111111111111111 -->

      <el-row>
        <el-col :span="18">


          <div style=" margin-right: 60px;">
            <div class="productDetail">
              <div class="detailTabs">

                <span :class="{compActive: currentComp === 'detailData' }"
                  @click="clickSwitchTab(type = 'detailData')">意向订单</span>
                <span :class="{compActive: currentComp === 'evaluation'}"
                  @click="clickSwitchTab(type = 'evaluation')">产品详情</span>
                <span :class="{compActive: currentComp === 'finalize'}"
                  @click="clickSwitchTab(type = 'finalize')">完成订单</span>
              </div>
              <div class="detailBox clearfix">
                <div class="detailInfoBox">
                  <div v-show="currentComp==='detailData'">
                    <div>
                      <el-row>
                        <el-col :span="24">
                          <div class="mokis">
                            <div>
                              <i style="color:#FB935B;" color="#FB935B" class="el-icon-s-open"></i>
                              <span class="mkoiua">商议订单中</span>
                            </div>
                            <div>
                              <span class="mkoiae">
                                2020-02-10
                              </span>
                              <span>
                                <span class="mkoiua"> ￥2000</span>/ 吨
                              </span>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="mokisas">
                            <span>MMM供应链管理公司 张三益-交易员 09:10</span>
                            <span>交货周期02-20至02-25</span>
                            <span><i style="color: #5F93FF;" class="el-icon-s-order"></i><span
                                class="dsafsw">查看详情</span></span>
                          </div>
                        </el-col>
                        <el-row class="dassaf">
                          <el-col :span="11" class="mokiiua">
                            <span>意向价格 ￥2000/吨</span>
                            <span>意向量 150/吨</span>
                          </el-col>
                          <el-col :span="13" class="mokiiua">
                            <span><i style="color: #5F93FF;" class="el-icon-s-order"></i><span
                                class="dsafsw">联系TA</span></span>
                            <span><i style="color: #5F93FF;" class="el-icon-s-order"></i><span
                                class="dsafsw">拒绝</span></span>
                            <span><i style="color: #5F93FF;" class="el-icon-s-order"></i><span
                                class="dsafsw">修改</span></span>
                          </el-col>
                        </el-row>
                      </el-row>
                    </div>

                  </div>
                  <div v-show="currentComp==='evaluation'">
                    <!-- 产品详情 -->
                    <div>
                      <div class="evaluation-box" v-for="(item, index) of list" :key="index">
                        <el-row :gutter="20" class="evaluation-content">
                          <el-col :span="5" class="img_name">
                            {{item.name}}
                          </el-col>
                          <el-col :span="19" class="evaluation-content-right">
                            <div class="evaluation-content-text"> {{item.province}}</div>
                            <div class="evaluation-content-img">

                            </div>
                            <!-- <div class="evaluation-content-date">日期</div> -->
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <!--        具体内容end-->
                  </div>

                  <div v-show="currentComp==='finalize'">

                  </div>
                </div>

              </div>
            </div>
          </div>




        </el-col>

        <!-- 2 -->
        <!-- <el-col :span="6">
          <span>推荐产品</span>
          <commodityDetails></commodityDetails>
        </el-col> -->
      </el-row>


    </div>
  </div>
</template>
<script>
  import GoodsImage from "./goods-image.vue"
  import commodityDetails from './commodity'
  export default {
    data () {
      return {
        count: '', //倒计时
        seconds: 864000,// 10天的秒数
        swiperList: [],
        marst: [{
          name: '竞拍总量',
          province: '2514000吨',


        }, {
          name: '申买量',
          province: '4000吨',

        },
        {
          name: '最低竞拍量',
          province: '100吨',

        },
        {
          name: '浏览量',
          province: '65842吨',

        },

        {
          name: '交易量',
          province: '154547吨',

        },
        {
          name: '交易量',
          province: '154547吨',

        },
        ],
        list: [{
          name: '交货方式',
          province: '库区自提',


        }, {
          name: '货源地',
          province: '山西太原',

        }, {
          name: '付款方式',
          province: '先付款后发货',

        }


        ],
        tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,

        }, {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }, {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }, {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }, {
          date: '2016-05-08',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }, {
          date: '2016-05-06',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }, {
          date: '2016-05-07',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333,
          zips: 200333,
        }],
        currentComp: 'detailData',//显示的内容，默认显示详情
        activeName: 'second'
      };
    },
    components: { GoodsImage },
    mounted () {
      this.Time() //调用定时器
    },
    methods: {
      countDown () {
        let d = parseInt(this.seconds / (24 * 60 * 60))
        d = d < 10 ? "0" + d : d
        let h = parseInt(this.seconds / (60 * 60) % 24);
        h = h < 10 ? "0" + h : h
        let m = parseInt(this.seconds / 60 % 60);
        m = m < 10 ? "0" + m : m
        let s = parseInt(this.seconds % 60);
        s = s < 10 ? "0" + s : s
        this.count = d + '天' + h + '时' + m + '分' + s + '秒'
      },
      //定时器没过1秒参数减1
      Time () {
        setInterval(() => {
          this.seconds -= 1
          this.countDown()
        }, 1000)
      },
      handleClick (tab, event) {
        console.log(tab, event);
      },
      clickSwitchTab (type) {
        this.currentComp = type
      },
    }
  };


</script>
<style lang="less" scoped>
  .goods-image {

    width: 1200px;
    margin: 0 auto;
    height: 102px;
  }

  .goods-info {
    min-height: 520px;
    background: #fff;
    display: flex;

    .media {
      width: 280px;
      height: 320px;
      padding: 30px 50px 30px 0px;
    }

    .spec {
      flex: 1;
      padding: 30px 65px 30px 0;

      text-align: left;
    }
  }

  /deep/ .el-tabs__header {


    margin: 0;
  }

  /deep/ .el-tab-pane {


    background: #ffffff;
  }

  /deep/ .el-tabs__content {
    background: #ffffff;

    padding-top: 15px;


  }

  .huanghang {
    overflow: hidden;
    text-overflow: ellipsis;
    /* 超出部分省略号 */
    word-break: break-all;
    /* break-all(允许在单词内换行。) */
    display: -webkit-box;
    /* 对象作为伸缩盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 2;
    /* 显示的行数 */
    max-height: 80rpx;
    /* 设置最大高度，根据行高，要几行乘以几倍 */
  }

  .xtx-button {
    appearance: none;
    border: none;
    outline: none;
    background: #fff;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;

    border-color: #5F93FF;
    background: #5F93FF;
    color: #fff;
    border-radius: 10px;
    width: 180px;
    height: 50px;
    font-size: 16px;

    margin-top: 24px;

    margin-bottom: 24px;
  }

  .fhas-buttons {
    appearance: none;
    border: none;
    outline: none;
    background: #fff;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    background: #5F93FF;
    opacity: 0.3;
    border-radius: 10px;
    width: 100px;
    height: 54px;
    background: #CFDEFF;
    opacity: 0.3;
    border-radius: 10px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #5F93FF;
    line-height: 28px;
  }

  .shoucan {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }

  .container {
    /* width: 300px; */
    min-height: 80px;
    /* 设置成为弹性盒子 */
    display: flex;
    /* 允许多行排列 */
    flex-wrap: wrap;
    text-align: center;


    border-bottom: 1px solid #CCCCCC;
  }

  .i-colea {

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }

  .gongsi {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .borearss {

    width: 48px;
    height: 48px;
    background: #5F93FF;
    border-radius: 50%;

    margin: 0 auto;

    margin-top: 10px;

    margin-bottom: 30px;
  }

  .moiuysa {
    background: #FFFFFF;
    border: 1px solid #5F93FF;
    border-radius: 8px;

    text-align: center;

    /* padding-top: 10px;


    padding-bottom: 10px; */

    margin-top: 25px;

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5F93FF;
    line-height: 28px;
  }

  .xian {

    /* height: 1px; */
    border: 1px solid #CCCCCC;

    margin-top: 20px;

    margin-bottom: 20px;
  }

  .moaksa {

    display: flex;
  }

  .siaosaf {

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }

  .anniu {
    background: #FEB960;
    border: none;


  }

  .siaosaf-q {
    margin-left: 22px;
    /* width: 67px; */
    /* height: 12px; */
    background: #FEB960;
    border-radius: 4px;
    /* padding: 5px; */

    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    /* line-height: 18px; */
  }

  .mokisa {

    text-align: center;

    margin: 0 auto;
  }

  .bang-rigth {
    min-width: 260px;
    height: 335px;
    background: #FFFFFF;
    border: 1px solid #ABC0EC;
    border-radius: 10px;

    margin: 0 auto;

    padding: 20px;

  }

  .i-coleasss {

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .container>.item {
    /* width: auto; */

    width: 30%;
    min-height: 30px;

    margin: 7px;
  }

  .container {
    /* 行中居中 */
    align-content: center;
  }

  .displa {
    display: flex;
    flex-direction: column;
    align-items: left;
    /* justify-content: space-between; */

    /* flex-direction: column; */
    /* display: flex;
    justify-content: center;
    align-items: center; */

    /* background-color: lightgrey; */
  }

  .evaluation-box {
    margin-right: 20px;

    /deep/ .img_name {
      display: flex;
      flex-direction: column;
      align-items: left;

      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;


      div {
        margin-bottom: 15px;
      }
    }

    .evaluation-content {
      margin-top: 25px;
      /* border-bottom: 1px solid #E5E5E5; */
    }
  }



  .productDetail {
    .detailTabs {
      margin-bottom: 30px;
      height: 46px;
      line-height: 46px;

      border-bottom: 2px solid #5F93FF;
      /* border: 1px solid #E5E5E5;

  
      background: #F6F6F6; */
      display: flex;

      span:nth-child(1) {

        /* background-color: #5F93FF; */
      }

      span {
        padding: 0 30px;
        /* border-right: 1px solid #E5E5E5; */
        cursor: pointer;
        color: #333333;
        font-size: 16px;
      }

      .compActive {
        background: #5F93FF;

        color: #ffffff;
      }
    }
  }

  .mokis {
    background: #FFE8D6;
    padding: 17px 30px;

    display: flex;
    justify-content: space-between;

  }

  .dsafsw {

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5F93FF;
  }

  .mokisas {

    padding: 17px 30px;


    display: flex;

    justify-content: space-between;

    border: 1px solid #EBEEF5;

  }

  .mokiiua {
    display: flex;

    /* justify-content: space-between; */
    justify-content: space-around;

    padding: 17px 0px;
  }

  .dassaf {
    border: 1px solid #EBEEF5;


  }

  .mkoiae {

    margin-right: 30px;
  }

  .mkoiua {

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FB935B;
    line-height: 28px;
  }

  .goods-sku {
    /* padding-left: 10px; */
    /* padding-top: 20px; */

    .clap {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;


    }

    .g-resa {

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
    }

    .iponer {

      position: relative;

      background: #F2F6FF;
      /* opacity: 0.77; */
      /* border-radius: 10px; */
      color: #ffffff;
      position: relative;
      padding: 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;
      /* border: 1px solid #CCDDFF; */

      .posasa {

        position: absolute;

        right: 32px;

        .riesa {

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 28px;

        }


      }

      .g-price {


        margin-top: 10px;

        .g-rena {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;


        }

        .g-mkous {

          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #E35953;
        }

      }
    }

    .rechargeItem {

      /* width: 290px; */
      overflow: hidden;
      border-radius: 20px;
      margin-bottom: 20px;
      margin-top: 18px;
    }

    .iperssaa {

      background: #DDECFA;
      /* opacity: 0.77; */
      cursor: pointer;
      padding: 20px;
      text-align: left;
      display: -webkit-box;
      display: -ms-flexbox;
      /* display: flex; */
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;

      .miaosha {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3166D6;
        line-height: 28px;
      }
    }

  }

  .w1200 {

    /* width: 1200px; */

  }

  /deep/.el-tabs--top {

    /* width: 1200px; */

    margin: 0 auto;
    /* text-align: left; */
  }

  /deep/.mokis {

    /* width: 1200px; */

    margin: 0 auto;

  }

  /deep/ .el-tabs__nav {

    width: 1200px;

    margin: 0 auto;

  }

  /deep/ .el-tabs__active-bar {
    background-color: transparent !important;
  }

  /deep/ .el-table__body tr.current-row>td {
    background-color: #add8e6 !important;

  }

  /*去掉tabs底部的下划线*/
  /deep/ .el-tabs__nav-wrap::after {
    position: static !important;
  }

  /deep/.el-tabs__nav-scroll {

    background-color: #5F93FF;
  }

  /deep/.el-tabs__item.is-active {

    color: #FFFFFF;
  }

  /deep/.el-tabs__item:hover {}

  /deep/ .el-tabs__item {

    color: #81AAFF;

  }


  .rechargeItemTop {

    background: #F2F6FF;
    /* opacity: 0.77; */
    /* border-radius: 10px; */
    color: #ffffff;
    position: relative;
    padding: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    border: 1px solid #CCDDFF;

  }

</style>



// WEBPACK FOOTER //
// src/view/goods-sku.vue